import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  LinearProgress,
  Button,
  Grid,
  Divider,
   useTheme,
   Chip,
  Stack,
  Avatar,
  alpha
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet";
import RedeemIcon from "@mui/icons-material/Redeem";

import CoinWalletGif from '../../../assets/RupeeCoinGif (1).gif'
import targetIcone from '../../../assets/Target.png'
import CouponIcon from '../../../assets/coupon_icon.png'

import rewardGirl from '../../../assets/reward_girl.png'
import couponGiftIcon from '../../../assets/couponGiftIcon.png'
import EarnMore from '../../../assets/QuickScan.gif'




import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import Cross from '../../../assets/crossIcon.png'
// ✅ Circular Progress Bar Component
const CircularProgressWithLabel = ({ value }) => {
  // ✅ Ensure integer
  const displayValue = Math.round(value);

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        width: 60,
        height: 60,
      }}
    >
      <svg width="60" height="60" viewBox="0 0 36 36">
        <path
          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none"
          stroke="#e6e6e6"
          strokeWidth="3"
        />
        <path
          d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831"
          fill="none"
          stroke="#4caf50"
          strokeWidth="3"
          strokeDasharray={`${displayValue}, 100`} // ✅ Use rounded value
        />
      </svg>
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="green"
          fontWeight="bold"
        >
          {`${displayValue}%`}
        </Typography>
      </Box>
    </Box>
  );
};


// ✅ Header + Milestone Component
const MilestoneScreen = ({ milestone = 1, progress = 0,couponData,currentReward }) => {
  return (
    <Box sx={{pt:8}}>
   
  

      {/* Milestone Card */}
      <Box sx={{ p: 2,    pt: 0}} style={{paddingBottom:"2px"}}>
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: "none",
            background:"none",
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" sx={{ color:"#A75919",fontWeight:100 }}>
            You&apos;re On{" "}
            <span style={{ color: "#A75919" }}><span style={{fontWeight: "bold"}}>Milestone {milestone}</span></span>
          </Typography>
          <CircularProgressWithLabel value={progress} />
        </Card>

        {/* Offer Section */}
        {currentReward?
<>

        {<Card
          sx={{
          
            borderRadius: 3,
            border: "1px solid #c9c9c9",
            background: "linear-gradient(to right, #e9ffe9, #fafffa)",
            boxShadow: 1,
          }}
        >
          <CardContent sx={{ display: "flex", alignItems: "center" }}>
            <img
              src={rewardGirl} // replace with your asset
              alt="offer"
              style={{ width: 60, marginRight: 10 }}
            />
        <Box>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "green" }}
              >
                Wohoo!
              </Typography>
              <Typography variant="body2" color="text.secondary">
                A Surprise Offer Has Been Applied
              </Typography>
            </Box>
            
      
          </CardContent>
        </Card>}</>:<Card
          sx={{
          
            borderRadius: 3,
            border: "1px solid #c9c9c9",
            background: "linear-gradient(90deg, #DEFEE6 0%, #FFFFC7 100%)",
            boxShadow: 1,
           
          }}
        >
          <CardContent sx={{ display: "flex", alignItems: "center", }} style={{padding:"10px"}}>
            <img
              src={EarnMore} // replace with your asset
              alt="offer"
              style={{ width: 60, marginRight: 10 }}
            />
    
            
               <Box>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color:"rgba(245, 109, 12, 1)"}}
              >
               Earn More!
              </Typography>
              <Typography variant="body2" color="rgba(245, 109, 12, 1)
">
             No Offer This Time, But You're Getting Closer 
              </Typography>
            </Box>
          </CardContent>
        </Card>}
      </Box>
    </Box>
  );
};




const CouponList = ({
    couponsList,
applyCoupon,
marginTop
}) => {

   const navigate=useNavigate()





   const handleOrderNow=()=>{
navigate('/',{replace:true})
   }



  return (
    <>
    

    <Box sx={{ bgcolor: "#ffffffff",  marginTop: "10px", }} style={{marginTop:marginTop?marginTop:""}}>
  





    {couponsList && couponsList.length> 0 ? (
  <div>
    <Box display={"flex"} mb={1} alignItems={"flex-end"}>
      <Typography
        variant="subtitle2"
        sx={{
          color: "brown",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
        }}
      >
        More Coupons Available
      </Typography>

      <Box
        component="img"
        src={CouponIcon} // your image or gif path
        alt="wallet"
        sx={{
          width: 30,
          height: 30,
          borderRadius: 2,
          ml: 1,
        }}
      />
    </Box>

    {/* Coupon List */}
    {couponsList.map((coupon, index) => (
      <Box
        key={index}
        sx={{
          position: "relative",
          display: "inline-block",
          width: "100%",
          mb: 2,
        }}
      >
     
        {/* Coupon Card */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: "none",
            border: "1px solid #d3d3d3",
            overflow: "hidden",
            position: "relative",
            width: "100%",
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
              p: 2,
              width: "100%",
            }}
          >
            {/* Left side */}
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <img
                src={targetIcone} // replace with your targetIcon
                alt="coupon"
                style={{ width: "56px", height: "56px" }}
              />

              {/* Vertical dotted divider */}
              <Box
                sx={{
                  borderLeft: "2px dashed #c9c9c9",
                  alignSelf: "stretch",
                  mx: 2,
                  mb: -3,
                  mt: -2,
                }}
              />

              {/* Coupon Details */}
              <Box sx={{ width: "100%" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "green" }}
                >
                  {coupon.couponName || "₹10 OFF"}
                </Typography>
                <Typography variant="body2" sx={{ color: "brown" }}>
                  {coupon.couponDescription || "On Your Next Order Above ₹40"}
                </Typography>


                {coupon.isApplicable==true?
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "white",
                    border: "1px solid #00c853",
                    color: "#00c853",
                    borderRadius: 3,
                    fontWeight: 700,
                    textTransform: "none",
                    width: "100%",
                    px: 3,
                    mt: 1,
                    "&:hover": {
                      bgcolor: "white",
                      color: "#00c853",
                    },
                  }}
                  onClick={(e) =>applyCoupon(e,coupon.couponId,coupon.couponName)}
                >
                  Claim
                </Button>: <Button
                  variant="contained"
                  sx={{
                    bgcolor: "white",
                    border: "1px solid #b1bfb7",
                    color: "#b1bfb7",
                    borderRadius: 3,
                    fontWeight: 700,
                    textTransform: "none",
                    width: "100%",
                    px: 3,
                    mt: 1,
                    "&:hover": {
                      bgcolor: "white",
                      color: "#b1bfb7",
                    },
                  }}
                  //onClick={(e) =>ApplyCoupons(e,coupon.couponName)}
                >
                  Claim
                </Button>}
               
              </Box>
            </Box>
          </CardContent>
        </Card>

        {/* Left half circle cutout */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            width: 16,
            height: 30,
            borderRadius: "0 20px 20px 0",
            bgcolor: "#fff",
            border: "1px solid #d3d3d3",
            borderLeft: "none",
          }}
        />

        {/* Right half circle cutout */}
        <Box
          sx={{
            position: "absolute",
            right: "-1px",
            top: "50%",
            transform: "translateY(-50%)",
            width: 16,
            height: 30,
            borderRadius: "20px 0 0 20px",
            bgcolor: "#fff",
            border: "1px solid #d3d3d3",
            borderRight: "none",
          }}
        />
      </Box>

      
    ))}
    <p style={{textAlign:"center",color:"rgba(167, 89, 25, 0.7)",fontSize:"12px"}}> Sometimes rewards come as surprises, so keep scanning after every purchase!</p>
  </div>
) : (
  <Card
    elevation={3}
    sx={{
      borderRadius: 4,
      p: 3,
      textAlign: "center",
      background: "linear-gradient(180deg, #fff, #f7f4ef)",
    }}
  >
    <CardContent>
      <Stack alignItems="center" spacing={3}>
        {/* Gift Box Image */}
        <img
          src={couponGiftIcon} // <-- replace with your gift image path
          alt="Gift"
          style={{ width: 120, height: "auto" }}
        />

        {/* Message */}
        <Typography
          variant="body1"
          sx={{
            color: "#9b5729",
            fontWeight: 500,
            maxWidth: 280,
          }}
        >
          You May Find New Gifts And Coupons On Next Order
        </Typography>

        {/* Order Now Button */}
        
        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: 700,
            fontSize: "1rem",
            borderRadius: "12px",
            px: 4,
            py: 1.2,
            bgcolor: "#1DB954", // green
            "&:hover": { bgcolor: "#17a44c" },
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          
          }}
            onClick={(e)=>{handleOrderNow()}}
        >
          Order Now
        </Button>
      </Stack>
    </CardContent>
  </Card>
)}
  
    </Box>
    </>
  );
};

export default CouponList;
